import { useId, useState } from 'react';

import { Button, type ButtonProps } from '@/components/ui/Button';
import { cx } from '@/lib/cx';

import styles from './VacancyIconButton.module.css';

type VacancyIconButtonProps = Omit<
  ButtonProps,
  'children' | 'variant' | 'size' | 'block' | 'iconAfter'
> & {
  label: string;
  danger?: boolean;
};

export function VacancyIconButton({
  label,
  danger = false,
  className,
  ...props
}: VacancyIconButtonProps) {
  const tooltipId = useId();
  const [showLabel, setShowLabel] = useState(false);

  return (
    <span
      className={styles.root}
      onMouseEnter={() => {
        setShowLabel(true);
      }}
      onMouseLeave={() => {
        setShowLabel(false);
      }}
      onFocus={() => {
        setShowLabel(true);
      }}
      onBlur={() => {
        setShowLabel(false);
      }}
      onKeyDown={(event) => {
        if (event.key === 'Escape') setShowLabel(false);
      }}
    >
      <Button
        {...props}
        variant="ghost"
        aria-label={label}
        aria-describedby={showLabel ? tooltipId : undefined}
        className={cx(styles.button, danger && styles.danger, className)}
      />
      {showLabel ? (
        <span id={tooltipId} role="tooltip" className={styles.tooltip}>
          {label}
        </span>
      ) : null}
    </span>
  );
}
